import React from "react";
import './Body2.css';
import picture11 from './source/picture11.png'
import picture12 from './source/picture12.png'
import picture13 from './source/picture13.png'
import picture14 from './source/picture14.png'



function Body2() {

  return (
    <div className="body2">
      <div className="body2-box1">
        <div className="body2-box2">
        <img className="body2-box2-picture11" src={picture11} alt="picture11"/>
        <img className="body2-box2-picture12" src={picture12} alt="picture12"/>
        <img className="body2-box2-picture13" src={picture13} alt="picture13"/>
        <img className="body2-box2-picture14" src={picture14} alt="picture14"/>
        </div>
      </div>
    </div>
  );
}

export default Body2;
